import { FC } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { activateMagicLink } from '@/api/magicLink/magicLink.actions.ts';
import Button from '@/components/controls/Button';

const ConfirmMagicLinkLogin: FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const router = useNavigate();

  const handleConfirm = async (): Promise<void> => {
    const response = await activateMagicLink(token as string);
    if (!response.success) {
      toast.error(response.error.message);
      return;
    }

    toast.success('You have logged in successfully');
    router('/');
  };

  return (
    <>
      <h1 className="text-2xl">Login with Magic link</h1>
      <div className="mt-10">
        <Button
          buttonStyle="justify-center items-center px-6 py-3 mt-2.5 text-base font-semibold text-white whitespace-nowrap bg-gray-900 rounded-lg max-md:px-5 w-full"
          text="Confirm Login"
          buttonType={{ type: 'button' }}
          hasImage={false}
          onClick={handleConfirm}
        />
      </div>
    </>
  );
};

export default ConfirmMagicLinkLogin;
